// Blur-crossfade page transitions (2026-08-21, per explicit request,
// replacing the removed Cross-Document View Transitions attempt — see
// main.css's own .page-veil comment for the full why). Plain hand-rolled
// overlay + click interception, not the native API, so it works
// identically in every real browser rather than depending on Chromium
// support for cross-document transitions specifically.
//
// The veil starts visible by default (main.css, not this script) so
// there's zero flash-of-clear-content before this file even loads. This
// script's only two jobs: (1) fade the veil away shortly after this page
// has loaded, (2) intercept real internal link clicks, fade the veil
// back in, and only then perform the actual navigation.
(function () {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const veil = document.querySelector(".page-veil");
  if (!veil) return;

  // Matches the .42s in main.css's .page-veil transition — kept as a
  // fallback safety net only (see beginExit below), not the primary
  // trigger, after a real bug where a hardcoded 380ms here fired
  // navigation slightly BEFORE the actual .42s/420ms CSS transition had
  // finished blurring in, so the page navigated away while still ~90%
  // faded rather than fully covered.
  const EXIT_DURATION_MS = 420;
  const EXIT_FALLBACK_MS = EXIT_DURATION_MS + 100;

  function clearVeil() {
    veil.classList.add("is-clear");
  }

  if (reducedMotion) {
    clearVeil();
    return;
  }

  // Double rAF: makes sure the browser has actually painted the blurred
  // starting state at least once before we start fading it away, rather
  // than the fade-in potentially collapsing to instant-clear on a very
  // fast/cached load.
  window.addEventListener("load", function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(clearVeil);
    });
  });

  document.addEventListener(
    "click",
    function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const a = e.target.closest("a[href]");
      if (!a || a.target === "_blank" || a.hasAttribute("download")) return;

      const href = a.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) return;

      let url;
      try {
        url = new URL(href, location.href);
      } catch (err) {
        return;
      }
      if (url.origin !== location.origin) return;
      // A same-page anchor jump (e.g. a footer link back to "/#meliza"
      // from another page is a real navigation and SHOULD transition;
      // this only skips a link to an anchor on the CURRENT page).
      if (url.pathname === location.pathname && url.hash) return;

      e.preventDefault();
      beginExit(url.href);
    },
    true
  );

  // transitionend is the real trigger — it fires exactly when the CSS
  // blur-in visually finishes, so navigation can never fire early (the
  // bug this replaced) or noticeably late. The setTimeout is only a
  // safety net in case transitionend never fires for some reason (e.g.
  // the tab is backgrounded and the transition gets throttled/paused
  // indefinitely) — without it, a missed event would leave the user
  // stuck staring at a blurred page forever with no way forward.
  function beginExit(href) {
    let navigated = false;
    function go() {
      if (navigated) return;
      navigated = true;
      location.href = href;
    }
    veil.addEventListener("transitionend", function onEnd(e) {
      if (e.propertyName !== "opacity") return;
      veil.removeEventListener("transitionend", onEnd);
      go();
    });
    setTimeout(go, EXIT_FALLBACK_MS);
    veil.classList.remove("is-clear");
  }
})();
